import {MemberDatabaseListModel} from '../member-management.model';
export class ExpiryDatesMemberModel {
  id: number;
  name:string;
  expiryDate: string;
  newExpiryDate: string;
  isPremium: boolean;
  memberObj: MemberDatabaseListModel;
  isPayingMember: boolean;
}
export class ExpireDatesMemberRequestModel {
  id: number;
  date: Date;
}




// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/member-management/member-actions/expiry-dates.model.ts